import { useState } from 'react';
import './CtaClutchBadgeFullWidth.css';
import topClutchCompany from '../../assets/images/top_clutch_company.png';
import personPowerpose from '../../assets/images/person-powerpose.png';
import ellipseYellow from '../../assets/images/ellipse-yellow.svg';
import ellipseBlue from '../../assets/images/ellipse-blue.svg';

export const CtaClutchBadgeFullWidth = ({
  heading,
  description,
  buttonLabel,
  siteUrl,
  onSubmit,
}) => {
  const [inputValue, setInputValue] = useState(siteUrl || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    const website = inputValue.trim();
    if (!website) return;
    if (onSubmit) {
      onSubmit(website);
    }
    const url = new URL('https://www.webfx.com/free-quote/');
    url.searchParams.set('website', website);
    window.location.assign(url.toString());
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div className="cta-clutch-badge">
      {/* Left Content Section */}
      <div className="cta-clutch-badge__left">
        {/* Text Content */}
        <div className="cta-clutch-badge__text">
          <h2 className="cta-clutch-badge__heading">{heading}</h2>
          <p className="cta-clutch-badge__description">{description}</p>
        </div>

        {/* Quick Start Form */}
        <form className="cta-clutch-badge__form" onSubmit={handleSubmit}>
          <input
            type="text"
            className="cta-clutch-badge__input"
            value={inputValue}
            onChange={handleInputChange}
            placeholder={siteUrl}
          />
          <button type="submit" className="cta-clutch-badge__button">
            {buttonLabel}
          </button>
        </form>
      </div>

      {/* Right Section - Images */}
      <div className="cta-clutch-badge__right">
        {/* Yellow decorative circle */}
        <div className="cta-clutch-badge__ellipse-yellow">
          <img src={ellipseYellow} alt="" />
        </div>

        {/* Clutch badge */}
        <div className="cta-clutch-badge__clutch-badge">
          <img src={topClutchCompany} alt="Top Clutch SEO Company 2025" />
        </div>

        {/* Person image */}
        <div className="cta-clutch-badge__person">
          <img src={personPowerpose} alt="" />
        </div>

        {/* Blue decorative circle */}
        <div className="cta-clutch-badge__ellipse-blue">
          <div className="cta-clutch-badge__ellipse-blue-inner">
            <img src={ellipseBlue} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

